// eslint-disable-next-line import/prefer-default-export
export function preventNewLines(e) {
  if (e.which === 13) {
    e.preventDefault();
  }
}
